import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import axios from 'axios'
import VueAxios from 'vue-axios'

import './assets/tailwind.css'

const pinia = createPinia()
const app = createApp(App)

// =============================
//  НАСТРОЙКА ЕДИНОГО AXIOS КЛИЕНТА
// =============================
const apiClient = axios.create({
  // Для Webpack (CLI) используй process.env или просто строку
  baseURL: 'https://pulsapp.kz/api', 
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// Перехватчик для добавления токена
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('auth_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// =============================
//  РЕГИСТРАЦИЯ В ПРИЛОЖЕНИИ
// =============================
app.use(pinia)
app.use(router)
app.use(VueAxios, apiClient)

// Глобальный доступ: this.$api
app.config.globalProperties.$api = apiClient

// Глобальная функция форматирования даты
app.config.globalProperties.$formatDate = (date) => {
  return new Date(date).toLocaleDateString('ru-RU')
}

app.mount('#app')
